<template>
    <div class="card">
        <div class="card-header p-0" id="headingFeatureable">
            <a
                class="btn btn-block text-left p-3"
                data-toggle="collapse"
                role="button"
                href="#collapseFeatureable"
                aria-expanded="false"
                aria-controls="collapseFeatureable">
                <h6 class="mb-0">{{ $t(`${modelTranslateID}.title`) }}</h6>
            </a>
        </div>

        <div id="collapseFeatureable"
            class="collapse"
            aria-labelledby="headingFeatureable"
            data-parent="">
            <div class="card-body">
                <div class="row">

                    <div class="col-sm-auto align-self-sm-center">
                        <div class="form-group">
                            <div class="form-check city-form-check pl-0">
                                <input
                                    class="form-check-input"
                                    type="checkbox"
                                    :id="`cb-featureable`"
                                    :name="`cb-featureable`"
                                    :disabled="readonlyForm || !this.hasResources"
                                    v-model="form.featureable"
                                    :false-value="false"
                                    :true-value="true"
                                    v-validate="''"
                                    :data-vv-scope="vScope">
                                <label class="form-check-label h-auto" :for="`cb-featureable`">
                                    <div class="d-flex flex-column align-items-start">
                                        <strong>{{ $t(`${modelTranslateID}.featureable`) }}</strong>
                                    </div>
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-3">
                        <div class="form-group">
                            <MaterialSelect
                                :disabled="disableField"
                                class="city-form-group city-bg"
                                id="input-property-id"
                                name="property-id"
                                label="name"
                                :options="resourceFields"
                                :reduce="option => option.name"
                                v-model.trim="form.property_id"
                                v-validate="{required: this.isFeatureable}"
                                :data-vv-scope="vScope"
                                :inputClasses="[{'is-invalid': fnHasError('property-id', vScope) }]"
                                :error="fnFirstError('property-id', vScope)">
                                {{ $t(`${modelTranslateID}.property_id`) }}
                            </MaterialSelect>
                        </div>
                    </div>
                    <div class="col-sm-3">
                        <div class="form-group">
                            <MaterialSelect
                                :disabled="disableField"
                                class="city-form-group city-bg"
                                id="input-property-name"
                                name="property-name"
                                label="name"
                                :options="resourceFields"
                                :reduce="option => option.name"
                                v-model.trim="form.property_name"
                                v-validate="{required: this.isFeatureable}"
                                :data-vv-scope="vScope"
                                :inputClasses="[{'is-invalid': fnHasError('property-name', vScope) }]"
                                :error="fnFirstError('property-name', vScope)">
                                {{ $t(`${modelTranslateID}.property_name`) }}
                            </MaterialSelect>
                        </div>
                    </div>
                    <div class="col-sm-3">
                        <div class="form-group">
                            <MaterialSelect
                                :disabled="disableField"
                                class="city-form-group city-bg"
                                id="input-property-description"
                                name="property-description"
                                label="name"
                                :options="resourceFields"
                                :reduce="option => option.name"
                                v-model.trim="form.property_description"
                                v-validate="''"
                                :data-vv-scope="vScope"
                                :inputClasses="[{'is-invalid': fnHasError('property-description', vScope) }]"
                                :error="fnFirstError('property-description', vScope)">
                                {{ $t(`${modelTranslateID}.property_description`) }}
                            </MaterialSelect>
                        </div>
                    </div>
                    <div class="col-sm-3">
                        <div class="form-group">
                            <MaterialSelect
                                :disabled="disableField"
                                class="city-form-group city-bg"
                                id="input-property-image"
                                name="property-image"
                                label="name"
                                :options="resourceFields"
                                :reduce="option => option.name"
                                v-model.trim="form.property_image"
                                v-validate="''"
                                :data-vv-scope="vScope"
                                :inputClasses="[{'is-invalid': fnHasError('property-image', vScope) }]"
                                :error="fnFirstError('property-image', vScope)">
                                {{ $t(`${modelTranslateID}.property_image`) }}
                            </MaterialSelect>
                        </div>
                    </div>

                    <div class="col-sm">
                        <div class="form-group">
                            <MaterialInput
                                :readonly="disableField"
                                :disabled="disableField"
                                class="city-form-group city-bg"
                                id="input-integration-id"
                                name="integration-id"
                                v-model.trim="form.integration_id"
                                v-validate="''"
                                :data-vv-scope="vScope"
                                :inputClasses="[{'is-invalid': fnHasError('integration-id', vScope) }]"
                                :error="fnFirstError('integration-id', vScope)">
                                {{ $t(`${modelTranslateID}.integration_id`) }}
                            </MaterialInput>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <MaterialSelect
                                :disabled="disableField"
                                class="city-form-group city-bg"
                                id="input-acl-code"
                                name="acl-code"
                                label="name"
                                :options="acls"
                                v-model.trim="form.acl_code"
                                :reduce="option => option.code"
                                v-validate="''"
                                :data-vv-scope="vScope"
                                :inputClasses="[{'is-invalid': fnHasError('acl_code', vScope) }]"
                                :error="fnFirstError('acl_code', vScope)">
                                {{ $t(`${modelTranslateID}.acl_code`) }}
                            </MaterialSelect>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <LayerSubtype
                            v-model="form.subtypes"
                            :idPanel="idPanel"
                            :idSubPanel="`${idSubPanel}.subtypes`"
                            :panelCfg="panelCfg"
                            :baseTranslateID="baseTranslateID"
                            :vScope="vScope"
                            :readonlyForm="disableField"
                            :subtypes="subtypes"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ElementMixin from '../mixins/ElementMixin';
import { isEmptyObject, formatUrl } from "@config/utils";

const resourceProperties = {
    property_id: null,
    property_name: null,
    property_description: null,
    property_image: null,
};

const defaultObj = {
    featureable: false,
    integration_id: null,
    acl_code: null,
    subtypes: [],
    ...resourceProperties
};

export default {
    name: 'LayerFeatureable',
    components: {
        LayerSubtype: () => import(/* webpackChunkName: "recursive-details-layer-subtypes" */ './LayerSubtype'),
    },
    mixins: [
        ElementMixin,
    ],
    props: {
        value: {
            type: Object,
            default: () => {
                return {};
            },
        },
        idSubPanel: {
            type: String,
            default: 'featureable',
        },
        acls: {
            type: Array,
            default: () => [],
        },
        subtypes: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            form: defaultObj,
            resourceFields: [],
        }
    },
    computed: {
        isFeatureable() {
            return  this.form?.featureable ?? false;
        },
        disableField() {
            return this.readonlyForm || !this.hasResources || !this.isFeatureable;
        },
    },
    methods:{
        resetResourceProperties() {
            this.form = Object.assign(this.form, {...resourceProperties});
        },
        setResourceProperties() {
            this.resetResourceProperties();
            if(this.isFeatureable) {
                this.loadDescribeResource()
                .then(data => {
                    this.resourceFields = data ?? [];
                })
            }
        },
    },
    watch: {
        value: {
            immediate: true,
            handler: function(value, oldValue){
                if(isEmptyObject(value)) {
                    this.form = Object.assign(this.form, {...defaultObj});
                }else{
                    this.form = value;
                }
            }
        },
        form: {
            immediate: true,
            deep: true,
            handler: function(value, oldValue){
                this.$emit('input', value);
            }
        },
        selectedResource: {
            immediate: false,
            deep: true,
            handler: function(value, oldValue){
                if(value && value?.id != oldValue?.id) {
                    this.setResourceProperties()
                }
            }
        },
        isFeatureable: {
            handler: function(value, oldValue){
                if(value != oldValue) {
                    this.setResourceProperties()
                }
            }
        },
    }
}
</script>